import type { ReactNode } from 'react';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../../components/ui/alert-dialog';
import { Button } from '../../../../components/Button';

interface DeleteConfirmDialogProps {
  children: ReactNode;
  title: string;
  onConfirm: () => void;
  isLoading?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export default function DeleteConfirmDialog({
  children,
  title,
  onConfirm,
  isLoading = false,
  open,
  onOpenChange,
}: DeleteConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>求人の削除</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="p-lg">
          <AlertDialogDescription>
            「{title}」を削除しますか？この操作は取り消せません。
          </AlertDialogDescription>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button color="secondary" size="md">
              キャンセル
            </Button>
          </AlertDialogCancel>
          <Button color="danger" size="md" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? '削除中...' : '削除'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
